import { isValueEmpty } from './isValueEmpty';

export function checkPlaceholder<Value>(
  value?: Value[],
  defaultValue?: Value[],
): boolean {
  return isValueEmpty(value) && isValueEmpty(defaultValue);
}
